import { filterConfig } from "@modules/global/filter-config.ts"
import { isMobile } from "@modules/util/device"
import { getCategories } from "../category"
import {
    getGroupedFilterKeysContact,
    getGroupedFilterKeysService,
    getGroupedFilterKeysTraits,
    getGroupedFilters,
} from "../filter"
import { FILTER_GROUP_NAME_MAP } from "../filter-group-name-map"

const filterGroupButtons = () => Array.from(document.querySelectorAll<HTMLElement>(".filter-button") || [])
const filterGroupTabs = () => Array.from(document.querySelectorAll<HTMLElement>(".filter-category-form") || [])
const categoryFormContainers = () =>
    Array.from(document.querySelectorAll<HTMLElement>(".category-form-container") || [])
const extendFilterButtons = () => Array.from(document.querySelectorAll<HTMLElement>(".trait-more-button ") || [])
const categoryFormContainer = (element: HTMLElement | null) => element?.closest<HTMLElement>(".category-form-container")

export function clearAllOpenTabs() {
    filterGroupButtons().map((groupButton) => groupButton.classList.remove("more-is-open"))
    filterGroupTabs().map((groupButton) => groupButton.classList.add("hide"))
    categoryFormContainers()?.map((container) => container.classList.add("hide"))
}

filterGroupButtons().map((groupButton) =>
    groupButton.addEventListener("click", (event: Event) => {
        if (!(event.target instanceof HTMLElement)) {
            return
        }

        const filterButton = event.target.closest<HTMLElement>(".filter-button")
        const openTabId = filterButton?.dataset.opens || ""
        openFilterTab(openTabId)
    }),
)

export function openFilterTab(openTabId: string) {
    const filterButton = document.querySelector(`[data-opens="${openTabId}"]`)
    const openNewFilterTab = !(filterButton?.classList.contains("more-is-open") || false)
    const filterTab = document.getElementById(openTabId)
    const formContainer = categoryFormContainer(filterTab)

    clearAllOpenTabs()

    if (!openNewFilterTab) {
        return
    }

    formContainer?.classList.remove("hide")
    filterButton?.classList.add("more-is-open")
    filterTab?.classList.remove("hide")
}

extendFilterButtons()?.map((button) =>
    button.addEventListener("click", (clickEvent: MouseEvent) => {
        if (!(clickEvent.target instanceof HTMLElement)) {
            return
        }

        const toggleButton = clickEvent.target.closest<HTMLElement>(".trait-more-button ")
        const collapsibleElement = toggleButton?.querySelector<HTMLAnchorElement>("a")
        const descriptionElement = toggleButton?.querySelector<HTMLDivElement>(".description")

        if (!(collapsibleElement instanceof HTMLElement)) {
            return
        }

        if (collapsibleElement.classList.contains("is-open")) {
            collapsibleElement.classList.remove("is-open")

            if (descriptionElement instanceof HTMLElement) {
                descriptionElement.innerText = collapsibleElement.dataset.moreText || ""
            }
            return
        }

        collapsibleElement.classList.add("is-open")

        if (descriptionElement instanceof HTMLElement) {
            descriptionElement.innerText = collapsibleElement.dataset.lessText || ""
        }
    }),
)

export function updateFilterTabsInDomMobile() {
    if (!isMobile()) {
        return
    }
    const categories = getCategories()
    const generalDescription = document.querySelector<HTMLElement>('[data-opens="general"] small')

    if (generalDescription) {
        if (categories.length > 0) {
            generalDescription.classList.add("chosen")
            generalDescription.innerHTML = categories
                .map((category) => FILTER_GROUP_NAME_MAP.rubrik.values[category].text)
                .sort()
                .join(", ")
        } else {
            generalDescription.classList.remove("chosen")
            generalDescription.innerHTML = "& exklusive Inhalte"
        }
    }

    // all filters follow
    const traitsDescription = document.querySelector<HTMLElement>('[data-opens="traits"] small')
    const servicesDescription = document.querySelector<HTMLElement>('[data-opens="services"] small')
    const contactsDescription = document.querySelector<HTMLElement>('[data-opens="contacts"] small')
    const displayGroupsService = getGroupedFilterKeysService()
    const displayGroupsContact = getGroupedFilterKeysContact()
    const displayGroupsTraits = getGroupedFilterKeysTraits()

    if (traitsDescription) updateFilterGroupInDomMobile(traitsDescription, displayGroupsTraits, "Alter, Aussehen, …")
    if (servicesDescription) updateFilterGroupInDomMobile(servicesDescription, displayGroupsService, "Von AV bis ZK")
    if (contactsDescription)
        updateFilterGroupInDomMobile(contactsDescription, displayGroupsContact, "Treffen, Zeiten, …")
}

function updateFilterGroupInDomMobile(el: HTMLElement, keys: string[], defaultText: string) {
    if (el) {
        if (keys.length > 0) {
            el.classList.add("chosen")
            el.innerHTML = filterGroupKeysToText(keys)
        } else {
            el.classList.remove("chosen")
            el.innerHTML = defaultText
        }
    }
}

export function filterGroupKeysToText(
    keys: string[],
    groupSeparater = ", ",
    displayGroupLabel: (g: string) => string = (g: string) => `${g}: `,
) {
    const grouped = getGroupedFilters()
    return keys
        .map((displayGroup) => {
            const groupName = grouped[displayGroup].groupName
            const values = grouped[displayGroup].values
            if (filterConfig.groups.select.includes(groupName)) {
                const from = !values[0] ? "" : `von ${values[0]}`
                const to = !values[1] ? "" : `bis ${values[1]}`
                return `${displayGroupLabel(displayGroup)}${from}${to ? " " : ""}${to}`
            }
            return `${displayGroupLabel(displayGroup)}${grouped[displayGroup].values
                .map((val) => FILTER_GROUP_NAME_MAP[groupName]?.values[val]?.text)
                .join(", ")}`
        })
        .join(groupSeparater)
}

updateFilterTabsInDomMobile()
$(() => {
    $("#fltCont").on("hide.bs.modal", clearAllOpenTabs)
})
